import { ChangeEvent, FC } from "react";
import muiVariables from "../../styles/mui-variables";
import { Box, SxProps, TextField, Theme } from "@mui/material";
import InputFieldComponentStyle from "./InputFieldComponentStyle";
interface InputProps {
  value?: string;
  type?: "text" | "number" | "password";
  label: string;
  placeHolder?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  error?: boolean | undefined;
  inputProps?: any;
  multiLine?: boolean;
  rows?: number;
  labelStyle?: string;
  name?: string;
  helperText?: any;
  disabled?: boolean;
  InputProps?: object;
  inputRef?: React.Ref<string>;
  sx?: SxProps<Theme>;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  inputPropsStyle?: React.CSSProperties;
  isSxBackgroundColor?: boolean;
  labelSmall?: string;
  marginTopStyle?: string;
  isDisabledColor?: boolean;
  isSideButtonExit?: boolean;
}

const InputFieldComponent: FC<InputProps> = ({
  value,
  label = "Set label",
  placeHolder,
  onChange = () => { console.warn("you have not assigned any function") },
  multiLine,
  rows,
  name,
  error,
  inputProps,
  onBlur,
  inputPropsStyle,
  isSxBackgroundColor,
  labelSmall,
  marginTopStyle,
  isDisabledColor,
  isSideButtonExit,
  ...props
}) => {
  return (
    <Box
      sx={{
        ...InputFieldComponentStyle.mainBox, marginTop: marginTopStyle ? marginTopStyle : "",
      }}
    >
      {label ? (
        <label style={InputFieldComponentStyle.inputLabel}>
          {label} {labelSmall && <small>{labelSmall}</small>}
        </label>
      ) : null}
      <TextField
        sx={{
          ".MuiOutlinedInput-root": {
            backgroundColor: isSxBackgroundColor
              ? muiVariables.avatarBgColor
              : undefined,
          },
          "& .MuiInputBase-inputMultiline": {
            backgroundColor: `${muiVariables.avatarBgColor}`,
            color: "black",
            borderRadius: "6px",
            fontWeight: 400,
            padding: "8.5px 14px !important",
          },
          "& .MuiInputBase-input.Mui-disabled": {
            WebkitTextFillColor: "black",
          },
          ...InputFieldComponentStyle.inputTextFiledSx,
          marginTop: label === "" ? "5px !important" : "",
        }}
        inputProps={{
          style: {
            ...InputFieldComponentStyle.inputPropsStyle,
            padding: isSideButtonExit
              ? {
                xs: "8.5px 6px",
                sm: "8.5px 6px",
                md: "8.5px 6px",
                lg: "8.5px 14px",
              }
              : "8.5px 14px",
            backgroundColor: isDisabledColor
              ? muiVariables.borderColor
              : muiVariables.avatarBgColor,
            ...inputPropsStyle,
          },
          ...inputProps,
        }}
        multiline={multiLine}
        rows={rows}
        variant="outlined"
        size="small"
        placeholder={placeHolder}
        margin="none"
        value={value}
        onChange={(e: ChangeEvent<HTMLInputElement>) => onChange(e)}
        name={name}
        error={error}
        fullWidth
        onBlur={onBlur}
        {...props}
      />
    </Box>
  );
};

export default InputFieldComponent;
